import useWeekdays from '@oberoninternal/travelbase-ds/hooks/useWeekdays';
import { SpecialOperatingHours } from '../generated/graphql';
import OperatingHoursRow from './OperatingHoursRow';
import Stack, { StackProps } from './Stack';

const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

type OperatingHoursType = Omit<SpecialOperatingHours, 'startDate' | 'endDate' | '__typename'>;

interface OperatingHoursProps extends StackProps {
    operatingHours: OperatingHoursType;
}
const OperatingHours = ({ operatingHours, ...rest }: OperatingHoursProps) => {
    const weekDates = useWeekdays({ weekStartsOn: 1 });

    return (
        <Stack spacing={3} {...rest}>
            {weekdays.map((weekday, weekdayIndex) => {
                const times = operatingHours?.[weekday];
                if (!times) {
                    return null;
                }

                return <OperatingHoursRow key={weekday} times={times} weekdate={weekDates[weekdayIndex]} />;
            })}
        </Stack>
    );
};

export default OperatingHours;
